<template>
  <div class="mit-volume-details pa-5">

    <BaseMitLoading :show="loading" :fullscreen="false"/>
    <MitVolumesAnalyticsTime v-if="timeseriesChart.datasets" :timeseriesActivity="timeseriesChart"/>
    <BaseMitDataTable
      title="Volume History"
      :page="paging.page"
      :pageSize="paging.pageSize"
      :totalItems="paging.totalItems"
      :pageSizes="{itemsPerPageOptions:[50, 100, 200, 300]}"
      :editable="false"
      :headers="headers"
      :items="data"
    >
    </BaseMitDataTable>
  </div>
</template>

<script>
import moment from 'moment';
import MitUnitsService from '../services/MitUnitsService.js';
let currentUnit = MitUnitsService.getUserVolumeUnit();
import MitStorageService from '../services/MitStorageService.js';
import BaseMitDataTable from '../../base/components/BaseMitDataTable.vue';
import BaseMitLoading from '../../base/components/BaseMitLoading.vue';

import MitVolumesAnalyticsTime from './MitVolumesAnalyticsTime.vue';

export default {
  name: 'MitVolumeDetails',
  components: {
    BaseMitLoading,
    BaseMitDataTable,
    MitVolumesAnalyticsTime
  },
  props: {
    id: String,
    // keyModel: Object,
    // existingKeyNames: Array,
    // title: String,
    // spacesModel: {
    //   type: Array,
    //   default: []
    // },
  },
  data: function() {
    return {
      loading:false,
      options:{},
      paging:{
        page:1,
        pageSize:-1,
        totalItems:0
      },
      headers:[
          {text: 'Size Available ('+currentUnit.unit+')',sortable: false, value: 'sizeConverted.available'},
          {text: 'Size Used ('+currentUnit.unit+')',sortable: false,value: 'sizeConverted.used'},
          {text: 'Size Total ('+currentUnit.unit+')',sortable: false,value: 'sizeConverted.total'},
          {text: 'Create Date',sortable: false,value: 'dates_local.createDt'},
          // {text: 'Edit Date',sortable: true,value: 'dates_local.lastEditedDt'}
        ],
      data:[],
      timeseriesChart: {
          datasets:null,
          title:'Data Used ('+currentUnit.unit+')',
          labelX:'',
          labelY:'Data ('+currentUnit.unit+')'
      },
      chartData: null
    }
  },
  created() {
    this.refreshData();
  },
  methods : {
    refreshData(){
      this.loading = true;
      MitStorageService.requestGetVolumeDetails(this.id)
        .then((data) => {
          this.loading = false;

          this.data = data.records;
          this.chartData = {
              datasets:[data.records]
          };


          this.timeseriesChart.datasets = [];

          let dataset = {
              label:'Volume',
              data:[]
          };
          for(let y = 0; y < data.records.length; y++){
              dataset.data.push({x:data.records[y].dates_local.createDt,
                                 y:data.records[y].sizeConverted.used});
          }
          this.timeseriesChart.datasets.push(dataset);


          this.paging.totalItems = data.total;
        })
        .catch((error) => {
          this.loading = false;
          console.log('An error occurred trying to get keys list', error);
        });
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
